import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wJ8gk54x1kzkNWPjLGpVx8/VU_Logo_Badge.png';
type BadgeProps = {
  size?: number;
  className?: string;
};

/**
 * The circular band-logo badge. Reused as an emblem / divider motif across the site.
 */
export function Badge({
  size = 96,
  className = ''
}: BadgeProps) {
  return <span className={`inline-block rounded-full overflow-hidden ring-4 ring-[var(--vu-gold)] shadow-[0_0_0_4px_var(--vu-black),0_8px_24px_rgba(0,0,0,0.6)] ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-9" data-mp="2rpb08ambp65p">
      <img src={LOGO_URL} alt="Virtually Unknown band badge logo" className="w-full h-full object-cover" loading="lazy" data-id="element-10" data-mp="2hqd1yfz3hy9i" />
    </span>;
}

/**
 * A close crop of the dog mascot for compact navigation use. The outer badge lettering
 * stays intact in the full Badge component everywhere else.
 */
export function MascotMark({
  size = 56,
  className = ''
}: BadgeProps) {
  return <span className={`relative inline-block shrink-0 overflow-hidden rounded-full border-2 border-[var(--vu-gold)] bg-[var(--vu-black)] shadow-[0_0_0_2px_var(--vu-black),0_4px_12px_rgba(0,0,0,0.55)] ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-11" data-mp="2tzqn18hyrpem">
      <img src={LOGO_URL} alt="Virtually Unknown dog mascot" className="absolute left-1/2 top-1/2 w-[210%] max-w-none -translate-x-1/2 -translate-y-1/2" data-id="element-12" data-mp="32ueqqu7w4z1b" />
    </span>;
}

/**
 * A small decorative circular divider using nested rings — the tour-sticker motif.
 */
export function BadgeDivider({
  label = '★'
}: {
  label?: string;
}) {
  return <div className="flex items-center justify-center gap-4 py-2" aria-hidden="true" data-id="element-13" data-mp="2k2lxcyowtbt2">
      <span className="h-px w-16 sm:w-28 bg-[var(--vu-gold)]/40" data-id="element-14" data-mp="2f1oh4rngmru7" />
      <span className="flex items-center justify-center w-11 h-11 rounded-full border-2 border-[var(--vu-gold)] text-[var(--vu-gold)] font-display text-lg" data-id="element-15" data-mp="3vgpqy3rl4xxl">
        {label}
      </span>
      <span className="h-px w-16 sm:w-28 bg-[var(--vu-gold)]/40" data-id="element-16" data-mp="3qk96bjjlh1p9" />
    </div>;
}